<script>
    import SvelteMarkdown from "svelte-markdown";
    const source = `
Abstraction is key to computer science. If every programmer and end-user had to think about layers of computer architecture, how logic gates work, and which semiconductor materials were used to construct a computer chip, we would be in a very different place. Being able to encapsulate parts of a system has enabled people to build on top of existing work without getting caught up in the weeds or needing to become an expert on everything.

Learning to think abstractly, computationally, or algorithmically is paramount in computer science education too. Many universities’ computer science faculty insist that the aim of their curricula is to cultivate this style of thinking and problem-solving, as opposed to the common misconception of teaching coding as a vocational skill.
`;
</script>

<section class="abstraction">
    <h2>Abstraction</h2>
    <SvelteMarkdown {source} />
</section>
